var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 13.5C10.9295 14.0741 11.4774 14.5491 12.1066 14.8929C12.7357 15.2367 13.4315 15.4411 14.1467 15.4923C14.8618 15.5435 15.5796 15.4403 16.2513 15.1897C16.9231 14.9392 17.5331 14.547 18.04 14.04L21.04 11.04C21.9508 10.097 22.4548 8.83394 22.4434 7.52296C22.432 6.21198 21.9061 4.95791 20.9791 4.03087C20.0521 3.10383 18.798 2.57799 17.487 2.5666C16.176 2.5552 14.913 3.05918 13.97 3.96997L12.25 5.67997M14.5 11.5C14.0705 10.9259 13.5226 10.4508 12.8934 10.107C12.2642 9.76328 11.5684 9.55886 10.8533 9.50765C10.1382 9.45643 9.42037 9.55961 8.74861 9.8102C8.07685 10.0608 7.46684 10.4529 6.95996 10.96L3.95996 13.96C3.04917 14.903 2.54519 16.166 2.55659 17.477C2.56798 18.788 3.09382 20.042 4.02086 20.9691C4.9479 21.8961 6.20197 22.422 7.51295 22.4334C8.82393 22.4447 10.0869 21.9408 11.03 21.03L12.74 19.32",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.c6b209dea07d0e80e734a449f2b7c03d.svg";
export { ForwardRef as ReactComponent };